import { useState } from 'react';
import { Card, Nav, Tab, TabContent, TabPane } from 'react-bootstrap';
import { useSelector } from 'react-redux';

import {
  OutboundRatesTab,
  UsagePricingTab,
  PricingTab,
  RequirementsTab,
  ServicesTab,
  OutboundServicesTab,
} from '@components/Order/Numbers/Tabs';

export const PlanDetailsCard = () => {
  const { showState } = useSelector((state) => state.plan.planInfo);
  const [activeMainKey, setActiveMainKey] = useState('Number');
  const activeMainKeyNumber = 'Number';
  const activeMainKeyInbound = 'Inbound';
  const activeMainKeyOutbound = 'Outbound';

  const [activeSubKey, setActiveSubKey] = useState('pricing');

  const [activeInboundSubKey, setActiveInboundSubKey] =
    useState('inboundPricing');

  const [activeOutboundSubKey, setActiveOutboundSubKey] =
    useState('outboundPricing');

  const getSubTabStyle = (isActive) => ({
    borderBottom: isActive ? '1px solid white' : undefined,
    marginBottom: isActive ? '1px' : undefined,
  });

  return (
    <Card className="mt-2">
      <Card.Header className="bg-didxl text-white pb-0 px-0">
        <Card.Text className="largeFontSize mb-3 px-3">
          Plan {showState.currentPlan.name}
        </Card.Text>

        <Nav
          variant="tabs"
          activeKey={activeMainKey}
          onSelect={(k) => setActiveMainKey(k)}
          className="border-bottom-0 px-3"
        >
          <Nav.Item>
            <Nav.Link
              eventKey="Number"
              className={`mb-0 py-1 ${
                activeMainKey === activeMainKeyNumber
                  ? 'bg-white text-primary'
                  : 'text-white border-0'
              }`}
              style={getSubTabStyle(activeMainKey === activeMainKeyNumber)}
            >
              Number
            </Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link
              eventKey="Inbound"
              className={`mb-0 py-1 ${
                activeMainKey === activeMainKeyInbound
                  ? 'bg-white text-primary'
                  : 'text-white border-0'
              }`}
              style={getSubTabStyle(activeMainKey === activeMainKeyInbound)}
            >
              Inbound
            </Nav.Link>
          </Nav.Item>
          {showState.currentPlan.outboundRates && (
            <Nav.Item>
              <Nav.Link
                eventKey="Outbound"
                className={`mb-0 py-1 ${
                  activeMainKey === activeMainKeyOutbound
                    ? 'bg-white text-primary'
                    : 'text-white border-0'
                }`}
                style={getSubTabStyle(activeMainKey === activeMainKeyOutbound)}
              >
                Outbound
              </Nav.Link>
            </Nav.Item>
          )}
        </Nav>

        <div className="border-bottom border-dark border-1 w-100 py-1" />

        {activeMainKey === activeMainKeyNumber && (
          <div className="pt-2 px-3">
            <Nav
              variant="tabs"
              activeKey={activeSubKey}
              onSelect={(k) => setActiveSubKey(k)}
              className="border-bottom-0"
            >
              <Nav.Item>
                <Nav.Link
                  eventKey="pricing"
                  className={
                    activeSubKey === 'pricing'
                      ? 'bg-white text-primary'
                      : 'text-white border-0'
                  }
                  style={getSubTabStyle(activeSubKey === 'pricing')}
                >
                  Pricing
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link
                  eventKey="requirements"
                  className={
                    activeSubKey === 'requirements'
                      ? 'bg-white text-primary'
                      : 'text-white border-0'
                  }
                  style={getSubTabStyle(activeSubKey === 'requirements')}
                >
                  Requirements
                </Nav.Link>
              </Nav.Item>
            </Nav>

            <div
              className="border-bottom border-dark border-1 w-100"
              style={{
                marginLeft: '-1rem',
                marginRight: '-1rem',
                width: 'calc(100% + 2rem)',
              }}
            />
          </div>
        )}

        {activeMainKey === activeMainKeyInbound && (
          <div className="pt-2 px-3">
            <Nav
              variant="tabs"
              activeKey={activeInboundSubKey}
              onSelect={(k) => setActiveInboundSubKey(k)}
              className="border-bottom-0"
            >
              <Nav.Item>
                <Nav.Link
                  eventKey="inboundPricing"
                  className={
                    activeInboundSubKey === 'inboundPricing'
                      ? 'bg-white text-primary'
                      : 'text-white border-0'
                  }
                  style={getSubTabStyle(
                    activeInboundSubKey === 'inboundPricing'
                  )}
                >
                  Pricing
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link
                  eventKey="inboundServices"
                  className={
                    activeInboundSubKey === 'inboundServices'
                      ? 'bg-white text-primary'
                      : 'text-white border-0'
                  }
                  style={getSubTabStyle(
                    activeInboundSubKey === 'inboundServices'
                  )}
                >
                  Reachability/Services
                </Nav.Link>
              </Nav.Item>
            </Nav>

            <div
              className="border-bottom border-dark border-1 w-100"
              style={{
                marginLeft: '-1rem',
                marginRight: '-1rem',
                width: 'calc(100% + 2rem)',
              }}
            />
          </div>
        )}

        {activeMainKey === activeMainKeyOutbound && (
          <div className="pt-2 px-3">
            <Nav
              variant="tabs"
              activeKey={activeOutboundSubKey}
              onSelect={(k) => setActiveOutboundSubKey(k)}
              className="border-bottom-0"
            >
              {showState.currentPlan.outboundRates && (
                <Nav.Item>
                  <Nav.Link
                    eventKey="outboundPricing"
                    className={
                      activeOutboundSubKey === 'outboundPricing'
                        ? 'bg-white text-primary'
                        : 'text-white border-0'
                    }
                    style={getSubTabStyle(
                      activeOutboundSubKey === 'outboundPricing'
                    )}
                  >
                    Pricing
                  </Nav.Link>
                </Nav.Item>
              )}
              {showState.currentPlan.outboundRates && (
                <Nav.Item>
                  <Nav.Link
                    eventKey="outboundServices"
                    className={
                      activeOutboundSubKey === 'outboundServices'
                        ? 'bg-white text-primary'
                        : 'text-white border-0'
                    }
                    style={getSubTabStyle(
                      activeOutboundSubKey === 'outboundServices'
                    )}
                  >
                    Outreach/Services
                  </Nav.Link>
                </Nav.Item>
              )}
            </Nav>

            <div
              className="border-bottom border-dark border-1 w-100"
              style={{
                marginLeft: '-1rem',
                marginRight: '-1rem',
                width: 'calc(100% + 2rem)',
              }}
            />
          </div>
        )}
      </Card.Header>

      <Card.Body>
        {activeMainKey === activeMainKeyNumber && (
          <Tab.Container activeKey={activeSubKey}>
            <TabContent>
              <TabPane eventKey="pricing">
                <PricingTab />
              </TabPane>
              <TabPane eventKey="requirements">
                <RequirementsTab />
              </TabPane>
            </TabContent>
          </Tab.Container>
        )}

        {activeMainKey === activeMainKeyInbound && (
          <Tab.Container activeKey={activeInboundSubKey}>
            <TabContent>
              <TabPane eventKey="inboundPricing">
                <UsagePricingTab />
              </TabPane>
              <TabPane eventKey="inboundServices">
                <ServicesTab />
              </TabPane>
            </TabContent>
          </Tab.Container>
        )}

        {activeMainKey === activeMainKeyOutbound && (
          <Tab.Container activeKey={activeOutboundSubKey}>
            <TabContent>
              {showState.currentPlan.outboundRates && (
                <TabPane eventKey="outboundPricing">
                  <OutboundRatesTab />
                </TabPane>
              )}
              {showState.currentPlan.outboundRates && (
                <TabPane eventKey="outboundServices">
                  <OutboundServicesTab />
                </TabPane>
              )}
            </TabContent>
          </Tab.Container>
        )}
      </Card.Body>
    </Card>
  );
};
